import { confirmSignIn, resetPassword, signIn } from "aws-amplify/auth";

import { getUsernameByEmail } from "../../../api/auth/getUsernameByEmail";

export async function resolveLoginUsername(login) {
  if (!String(login || "").includes("@")) return login;

  const response = await getUsernameByEmail({ email: login });
  return response?.username || login;
}

export function signInWithPassword({ username, password }) {
  return signIn({ username, password });
}

export function confirmLoginChallenge({ challengeResponse, user }) {
  return confirmSignIn({
    challengeResponse,
    options: { user },
  });
}

export function startPasswordReset({ username }) {
  return resetPassword({ username });
}
